<div class="content">
    <div class="login">
        <img src="../../assets/img/login.png" alt="Logo App">
        <label for="user">User</label>
        <input type="text" id="user" [(ngModel)]="username" (keyup.enter)="login()">
        <label for="pass">Password</label>
        <input type="password" id="pass" (keyup.enter)="login()">
        <a class="button" (click)="login()">LOGIN</a>
        <a routerLink="" class="forgot">Forgot your password?</a>
        <a routerLink="" class="version">Version 1.0</a>
    </div>
</div>
<div class="footer">
    <p class="text-footer">2021 Inter-American Development Bank.</p>  
    <img class="logo-bid" src="../../assets/img/footer-login.png" alt="BID">
</div>
   
